import { Component, Input } from '@angular/core';
import { Storage } from '@ionic/storage';
import { LoopBackConfig } from "../../shared/sdk/lb.config";
import { ModalController } from 'ionic-angular';
import { StoragePathProvider } from '../../providers/storage-path/storage-path';
import { GDAuthInterface } from '../../model/gd-auth';
import { NestApiProvider } from '../../shared/nestjs/nest-api';

/**
 * Generated class for the ImageComponent component.
 *
 * See https://angular.io/docs/ts/latest/api/core/index/ComponentMetadata-class.html
 * for more info on Angular Components.
 */
@Component({
  selector: 'image-component',
  templateUrl: 'image-component.html'
})
export class ImageComponent {

  @Input() content;
  @Input() data;
  @Input() type;
  @Input() userid;
  @Input() userinitial; // for profile when loading or errror
  @Input() roomid; // for chat
  @Input() picture;
  @Input() viewable;
  @Input() pinch: boolean = false;

  public imageUrl: any;
  public isShow: boolean = true;
  toggleProfileError: boolean = false;
  private SFGoAuth: GDAuthInterface;

  constructor(
    public modalCtrl: ModalController,
    public storage: Storage,
    public storagePathProvider: StoragePathProvider,
    private nestApi: NestApiProvider
  ) {
    this.imageUrl = "assets/images/photonotavailable.jpg";
  }

  ngOnInit() {
    if (this.type == 'PROFILE') {
      this.imageUrl = "assets/images/photonotavailable.jpg";
    } else {
      this.imageUrl = "assets/images/imagenotavailable.png";
    }
  }

  public async ngOnChanges(): Promise<void> {
    try {
      await this.storage.ready();
      let hasil = await this.storage.get('SFGoAuth');
      this.SFGoAuth = hasil ? JSON.parse(hasil) : {};
      switch (this.type.replace(/[^a-zA-Z ]/g, "")) {
        case 'EMERGENCY':
          try {
            const storagePath = await this.storagePathProvider.getStorageEmergency();
            this.imageUrl = this.storagePathProvider.getUrlDownload(storagePath.urlDownload, encodeURIComponent(this.picture));
            console.log('image url', this.imageUrl);
          } catch (error) {
            this.imageUrl = '';
          }
          break;
        case 'PST':
          try {
            const storagePath = await this.storagePathProvider.getStoragePost();
            this.imageUrl = this.storagePathProvider.getUrlDownload(storagePath.urlDownload, encodeURIComponent(this.picture));
            console.log('image url', this.imageUrl);
            // let loopbackPath: string = LoopBackConfig.getPath();
            // let storageName = (JSON.parse(hasil).companyCode).toLowerCase();
            // loopbackPath + '/api/StoragePosts/' + storageName + '/download/' + encodeURIComponent(this.picture);
          } catch (error) {
            this.imageUrl = '';
          }
          break;
        case 'CHTPERSONAL':
          try {
            let loopbackPath: string = LoopBackConfig.getPath();
            let storageName = (JSON.parse(hasil).companyCode).toLowerCase() + '_Personal_' + this.userid;
            this.imageUrl = loopbackPath + '/api/StorageChats/' + storageName + '/download/' + this.picture;
          } catch (error) {
            this.imageUrl = '';
          }
          break;
        case 'CHTGROUP':
          try {
            let loopbackPath: string = LoopBackConfig.getPath();
            let storageName = (JSON.parse(hasil).companyCode).toLowerCase() + '_Group_' + this.userid;
            this.imageUrl = loopbackPath + '/api/StorageChats/' + storageName + '/download/' + this.picture;
          } catch (error) {
            this.imageUrl = '';
          }
          break;
        // NEW FOR CHAT
        case 'CHATMESSAGE':
          try {
            const storage = await this.storagePathProvider.getStorageChat({ roomId: this.roomid })
            this.imageUrl = storage.urlDownload + this.picture
          } catch (error) {
            this.imageUrl = '';
          }
          break;
        case 'CHATPROFILE':
          try {
            const storage = await this.storagePathProvider.getStorageChat({ roomId: this.roomid })
            this.imageUrl = storage.urlDownloadProfile + this.picture
          } catch (error) {
            this.imageUrl = '';
          }
          break;
        // END FOR CHAT
        case 'PROFILE':
          try {
            let loopbackPath: string = LoopBackConfig.getPath();
            let photopath: string = JSON.parse(hasil).empphotopath || null;
            if (photopath) {
              /** hapus &nosquare jika path tidak terdapat path inisial getimage& */
              if (photopath.indexOf('getimage&') == -1) {
                const fileName = this.picture.replace("&nosquare", "");
                this.picture = fileName;
              }
              this.imageUrl = encodeURI(photopath + this.picture);
            } else {
              const isGopathNew = await this.nestApi.isGoPathNewExist()
              if (isGopathNew) {
                const storagePath = await this.storagePathProvider.getStorageProfileCustom(this.userid);
                this.imageUrl = this.storagePathProvider.getUrlDownload(storagePath.urlDownload, this.picture);
              } else {
                let storageName = (JSON.parse(hasil).companyCode).toLowerCase() + '_' + this.userid;
                this.imageUrl = loopbackPath + '/api/StorageProfiles/' + storageName + '/download/' + this.picture;
              }
            }
          } catch (error) {
            this.imageUrl = '';
            this.toggleProfileError = true;
          }
          break;
        case 'PROFILE2':
          try {
            let loopbackPath: string = LoopBackConfig.getPath();
            let photopath = JSON.parse(hasil).empphotopath || null;
            if (photopath) {
              this.imageUrl = encodeURI(photopath + this.picture);
            } else {
              let storageName = (JSON.parse(hasil).companyCode).toLowerCase() + '_' + this.userid;
              this.imageUrl = loopbackPath + '/api/StorageProfiles/' + storageName + '/download/' + this.picture;
            }
          } catch (error) {
            this.imageUrl = '';
            this.toggleProfileError = true;
          }
          break;
        case 'CLAIM':
          try {
            let loopbackPath: string = LoopBackConfig.getPath();
            let claimpath = JSON.parse(hasil).claimpath
            if (claimpath) {
              this.imageUrl = claimpath + this.picture;
            } else {
              let storageName = (JSON.parse(hasil).companyCode).toLowerCase() + '_' + this.userid;
              this.imageUrl = loopbackPath + '/api/StorageClaims/' + storageName + '/download/' + this.picture;
            }
          } catch (error) {
            this.imageUrl = '';
          }
          break;
        case 'ATTENDANCE':
          try {
            const storagePath = await this.storagePathProvider.getStorageAttendance(this.SFGoAuth, this.SFGoAuth.userId);
            this.imageUrl = this.storagePathProvider.getUrlDownload(storagePath.urlDownload, this.picture);
          } catch (error) {
            this.imageUrl = '';
          }
          break;
        case 'ACTIVITYRECORDING':
          try {
            let loopbackPath: string = LoopBackConfig.getPath();
            const isGopathNew = await this.nestApi.isGoPathNewExist()
            if (isGopathNew) {
              const path = await this.storagePathProvider.getStorageActivityRecord();
              this.imageUrl = path.urlDownload + '?fileName=' + this.picture;
            } else {
              let storageName = this.userid;
              this.imageUrl = loopbackPath + '/api/StorageActivities/' + storageName + '/downloadFile/' + encodeURIComponent(this.picture);
            }
          } catch (error) {
            this.imageUrl = '';
          }
          break;
        case 'APPLICANT':
          try {
            let photopath: string = JSON.parse(hasil).appphotopath || null;
            if (photopath) {
              /** hapus &nosquare jika path tidak terdapat path inisial getimage& */
              if (photopath.indexOf('getimage&') == -1) {
                const fileName = this.picture.replace("&nosquare", "");
                this.picture = fileName;
              }
              this.imageUrl = encodeURI(photopath + this.picture);
            } else {
              this.imageUrl = '';
            }
          } catch (error) {
            this.imageUrl = '';
            this.toggleProfileError = true;
          }
          break;
        case 'LOGO':
          console.log('pic', this.picture)
          this.imageUrl = this.picture;
          break;
        case 'DUMMY':
          this.imageUrl = this.picture;
          break;
        default:
          this.imageUrl = this.picture;
      }
      this.isShow = true;
    } catch (error) {
      this.imageUrl = this.picture;
      this.isShow = true;
    }
  }


  viewImages(imageUrl) {
    if (this.viewable) {
      const modal = this.modalCtrl.create('ImageViewerPage', {
        images: imageUrl
      });
      modal.present();
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/image-component/image-component.ts